export class ErrorAuthHandle extends Error {
	constructor() {
		super();

		this.name = 'ErrorAuthHandle';
	}
}
